import cls from "classnames";
import Button from "@qoohoo/common/components/library/Button";

export default function BackButton({ handleBackButton, disabled }) {
  return (
    <Button
      className="text-[#7B8185] group !w-[120px] -left-8"
      size={Button.SIZE.small}
      onClick={handleBackButton}
      disabled={disabled}
    >
      <div className="relative flex flex-row items-center justify-center gap-2">
        <img
          src="/assets/icons/back.svg"
          alt="back"
          className={cls(
            "w-4 h-4 transition-transform",
            disabled ? "" : "group-hover:translate-x-[-4px]"
          )}
        />
        Back
      </div>
    </Button>
  );
}
